import { render, staticRenderFns } from "./common-version-input.vue?vue&type=template&id=3c35dff4&scoped=true"
import script from "./common-version-input.vue?vue&type=script&lang=js"
export * from "./common-version-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35dff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c35dff4')) {
      api.createRecord('3c35dff4', component.options)
    } else {
      api.reload('3c35dff4', component.options)
    }
    module.hot.accept("./common-version-input.vue?vue&type=template&id=3c35dff4&scoped=true", function () {
      api.rerender('3c35dff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/popups/common/common-version-input.vue"
export default component.exports